import {
	GET_GROUP_SETTINGS_FAIL,
	GET_GROUP_SETTINGS_REQ,
	GET_GROUP_SETTINGS_SUCCESS,
	SAVE_GROUP_SETTINGS_FAIL,
	SAVE_GROUP_SETTINGS_REQ,
	SAVE_GROUP_SETTINGS_SUCCESS,
} from '../constants/groupSettings';

export const groupSettingsReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_GROUP_SETTINGS_REQ:
			return { loading: true };
		case GET_GROUP_SETTINGS_SUCCESS:
			return { loading: false, groupSetting: action.payload };
		case GET_GROUP_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		case SAVE_GROUP_SETTINGS_REQ:
			return { ...state, loading: true };
		case SAVE_GROUP_SETTINGS_SUCCESS:
			return { ...state, loading: false };
		case SAVE_GROUP_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		default:
			return state;
	}
};
